export default __webpack_public_path__ + "static/media/Mrutynjaya Sahoo_Resume.51a4eb1a.pdf";